module.exports = __webpack_public_path__ + "static/img/banner1.b8fc6f8a.png";